import React from 'react';

import './index.css';

export default props => {
    return (
        <div className='display'>{props.value}</div>
    )
}